import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataPagination } from 'projects/access-control/src/app/Domain/Adapters';
import { DataTranslatePages } from 'projects/access-control/src/app/Domain/Entities/data-translate-pages';
import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
import { UsersGroups } from 'projects/access-control/src/app/Domain/Entities/userGroups.interface';
import { getUser } from 'projects/access-control/src/app/Infrastructure/Store/users/users.actions';
import { selectUserState } from 'projects/access-control/src/app/Infrastructure/Store/users/users.selectors';
import { ModalUsersComponent } from 'projects/access-control/src/app/UI/components/modal-users/modal-users.component';
import { TranslateService } from '@mangosoft/mango-layout';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-users',
	templateUrl: './users.component.html',
	styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit, OnDestroy {
	translateUsers: DataTranslatePages = {} as DataTranslatePages;
	subscriptionTranslate!: Subscription;
	pagination: DataPagination = {} as DataPagination;
	subscriptionUsers!: Subscription;
	userTable: UsersGroups[] = [];
	isLoading = false;
	columns: any[] = [
		{ name: 'username', label: 'Username' },
		{ name: 'fullName', label: 'Full Name' },
		{ name: 'email', label: 'Email' },
		{ name: 'phone', label: 'Phone' },
	];
	constructor(
		private translateService: TranslateService,
		private store: Store,
		private dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.store.dispatch(getUser({ paginationTo: 1 }));
		this.getTranslate();
		this.getUsers();
	}

	getTranslate() {
		this.subscriptionTranslate = this.translateService.init('AccessControl').subscribe((data) => {
			this.translateUsers = data.pages.users;
			this.columns = data.pages.users.columsFilter;
		});
	}
	openNewUser() {
		const dialogRef = this.dialog.open(ModalUsersComponent, {
			height: '750px',
			width: '600px',
			data: {
				type: 'newUserGlobal',
				group: {},
				user: {},
			},
		});
	}

	getUsers() {
		this.subscriptionUsers = this.store
			.pipe(select(selectUserState))
			.subscribe(({ users, pagination, loading }) => {
				this.userTable = users;
				this.pagination = pagination;
				this.isLoading = loading;
			});
	}

	ngOnDestroy(): void {
		this.subscriptionUsers?.unsubscribe();
		this.subscriptionTranslate?.unsubscribe();
	}
}
